import { apiRequest } from "@/services/api-client";
import {
  EnqueuePlayerInput,
  EnqueuePlayerOutput,
  WebAppRoutes,
} from "types/web-app";

export const enqueuePlayer = (input: EnqueuePlayerInput) =>
  apiRequest<EnqueuePlayerOutput>(`/${WebAppRoutes.ENQUEUE_PLAYER}`, {
    method: "POST",
    body: JSON.stringify(input),
  });
